module.exports = __webpack_public_path__ + "static/media/card.8ca06502.webp";